import { lazy, Suspense, useState } from 'react'
//import { ReactComponent as Icon } from "../../assets/svg/ContentImage.svg";
import { useTranslation } from 'react-i18next'
import { useUser } from '../../auth'
import Overview from './contents/Overview'
import { useEffect } from 'react'
import { getStudentDailyQuestionUsage } from '../../server/server'
import BannerSkeleton from './skeleton/BannerSkeleton'
import ResultsSkeleton from './contents/skeleton/ResultsSkeleton.jsx'
import FeedSkeleton from './contents/skeleton/FeedSkeleton.jsx'
import MyTasksSkeleton from './skeleton/MyTasksSkeleton.jsx'
import ButtonSkeleton from './skeleton/ButtonsSkeleton.jsx'

const WelcomeBanner = lazy(() => import('./WelcomeBanner'))

const MyTask = lazy(() => import('./MyTask'))

const ContentDashboard = lazy(() => import('./contents/ContentDashboard'))

const Feed = lazy(() => import('./contents/Feed'))

function Content({ refresh, setRefresh, setContentState }) {
    const { t } = useTranslation()
    const { user } = useUser()
    const [expanded, setExpanded] = useState(true)
    const [loadingStudentPercentage, setLoadingStudentPercentage] = useState(true)
    const [studentUsagePercentage, setStudentUsagePercentage] = useState(0.3)
    const [selContent, setSelContent] = useState('overview')
    const [notifications, setNotifications] = useState({ overview: 0, classroom: 0, feed: 0 })
    const [openTasksNumber, setOpenTasksNumber] = useState(0)
    const [refreshTasks, setRefreshTasks] = useState(0)

    const contentListMap = {
        overview: t('overview'),
        contentResults: t('results'),
        feed: t('feedPosts'),
        myTask: t('myTasks'),
    }

    const renderContentMap = {
        overview: <Overview />,
        contentResults: (
            <Suspense fallback={<ResultsSkeleton />}>
                <ContentDashboard refresh={refresh} setRefresh={setRefresh} />
            </Suspense>
        ),
        feed: (
            <Suspense fallback={<FeedSkeleton />}>
                <Feed />
            </Suspense>
        ),
        myTask: (
            <Suspense fallback={<MyTasksSkeleton />}>
                <MyTask user={user} scrollId={'small-screen-scroll'} setRefreshTasks={setRefreshTasks} />
            </Suspense>
        ),
    }

    useEffect(() => {
        setNotifications({ ...notifications, [selContent]: 0 })
        fetchStudentPercentage()
    }, [selContent])

    const fetchStudentPercentage = async () => {
        const resp = await getStudentDailyQuestionUsage()
        if (resp.status == 200) {
            setLoadingStudentPercentage(false)
            setStudentUsagePercentage(resp.data)
        } else {
            setLoadingStudentPercentage(false)
        }
    }

    const contentList = user.hasOnlyPrimaryStudents ? ['overview', 'feed'] : ['overview', 'contentResults', 'feed', 'myTask']
    return (
        <div className=" rounded-xl w-full flex flex-col h-full justify-center ">
            <Suspense
                fallback={
                    <>
                        <BannerSkeleton />
                        <div className="flex flex-row gap-[15px] mt-[15px]">
                            <ButtonSkeleton />
                        </div>
                    </>
                }
            >
                <WelcomeBanner />

                <div className="flex flex-col z-[1] mt-[15px]">
                    <div className="flex flex-row gap-[15px]">
                        {contentList.map((button, index) => {
                            const isSelected = button === selContent
                            return (
                                <button
                                    className={`rounded-[10px] px-[30px] h-[60px] relative xxs:flex flex-row items-center justify-center gap-1    ${
                                        button === 'myTask' ? 'xl:hidden' : ''
                                    } ${isSelected ? 'bg-aquaPulse' : 'bg-deep-ocean'} `}
                                    onClick={() => {
                                        setSelContent(button)
                                        setContentState(button)
                                    }}
                                    key={index}
                                >
                                    <div className={`dashboard-welcome-button ${isSelected ? 'text-textLight' : 'text-aquaPulse'}`}>{contentListMap[button]}</div>

                                    <div
                                        className={`w-[22px] h-[22px] absolute rotate-45 -bottom-[9px]  rounded-[2px]  left-[50%] -translate-x-[50%] ${
                                            isSelected ? 'bg-aquaPulse' : 'bg-deep-ocean'
                                        }`}
                                    ></div>
                                </button>
                            )
                        })}
                    </div>
                </div>
            </Suspense>
            <div className={`w-full mt-6 min-h-0 grow ${selContent === 'myTask' ? 'xl:hidden' : ''}`}>{renderContentMap[selContent]}</div>
        </div>
    )
}

export default Content
